import { connect } from 'react-redux';
import { point } from '@turf/helpers';
import { Config } from '@leverege/plugin';
import { Toast } from '@leverege/ui-elements';
import { GlobalState, UI } from '@leverege/ui-redux';
import { MapControl } from '@leverege/ui-mapbox-elements';
import I18N from '@leverege/i18n';
import GeoUtil from "../../dataViewers/map/shared/GeoUtil.js";
import UserPosition from "../../dataViewers/map/shared/UserPosition.js";
import MapViewerModel from "../../dataViewers/map/shared/models/MapViewerModel.js";
import UserPositionModel from "../../dataViewers/map/shared/renderers/UserPositionModel.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.map.centerOnUser');
export default {
  id: 'userPosition.action.centerOnUser',
  type: 'map.centerOnUser',
  name: tf('name'),
  matches: [{
    use: Config.get('MapScreen', 'centerUserActionBar', 'topLeftActionBar'),
    client: ['MapDataViewer', 'GoogleMapsDataViewer']
  }],
  layout: {
    sort: 'zzz'
  },
  appearance: ({
    context
  }) => {
    const ui = UI.get(GlobalState.get());
    const loading = ui.position?.loading;
    let icon;
    if (loading) {
      icon = tIcon('loadingIcon', 'fa fa-circle-o-notch fa-fw fa-spin');
    } else {
      icon = Config.get('MapScreen', 'centerUserIcon', tIcon('centerUserIcon', 'https://storage.googleapis.com/molten-ui-assets/icon-center-user.png'));
    }
    return {
      name: t('name'),
      icon
    };
  },
  perform: async ({
    context
  }) => {
    const {
      clientProps,
      mapViewer
    } = context;
    const {
      mapName,
      paginator
    } = clientProps;
    try {
      const position = await UserPosition.getPositionImmediate();
      if (position) {
        const {
          coords
        } = position;
        const features = GeoUtil.getFeatureList(paginator.pageItems);
        features.push(point([coords.longitude, coords.latitude]));
        const bbox = GeoUtil.getLatLonBounds(features);
        const {
          point: mapPoint,
          bounds
        } = GeoUtil.getBoundsOrPointFromBBox(bbox);
        if (bounds) {
          MapControl.flyToBounds(mapName, bounds, {
            padding: 60
          });
        } else if (mapPoint) {
          const zoom = mapViewer.map?.getZoom() < 16.1 ? 18 : mapViewer.map?.getZoom();
          MapControl.flyTo(mapName, {
            ...mapPoint,
            zoom
          });
        }
      }
    } catch (err) {
      if (err.code === 1) {
        Toast.error([t('errorTitle'), t('errorBody')], {
          autoClose: false
        });
      } else if (err.code === 3) {
        Toast.warn([t('warnTitle'), t('warnCode3')]);
      } else {
        Toast.warn([t('warnTitle'), err.message]);
      }
    }
  },
  // handles clicks on unoccupied map space
  handles: context => {
    const {
      clientProps: {
        model
      },
      streetView
    } = context;
    const ui = UI.get(GlobalState.get());
    const authorized = ui.position?.authorized;
    const userPositionLayer = model && MapViewerModel.getLayerByName(model, UserPositionModel.layerName);
    const isVisible = userPositionLayer ? UserPositionModel.getVisible(userPositionLayer) : true;
    return authorized !== false && isVisible && !streetView;
  },
  customComponent: connect(state => ({
    authorized: state.ui.position?.authorized,
    loading: state.ui.position?.loading
  }))(CenterOnUserComponent)
};
function CenterOnUserComponent(props) {
  const {
    factory,
    ...rest
  } = props;
  return factory.createComponent(rest);
}